import React, {useState, useEffect} from 'react'
import axios from 'axios'
import EditableProd from '../components/EditableProd'
import KuroLink from '../components/common/KuroLink'
import '../styles/products.css'

const NetworkingGear = () => {

    const [networkData, setNetworkData] = useState(null)

    useEffect(() => {
        axios(process.env.REACT_APP_KG_API_URL + 'kuroadmin/networking?type=wifi-card').then(res => {
            setNetworkData(res.data)
        })
    }, [])

    return (
        <div className="products">
            <p className="breadcrumb txt-light-grey"><KuroLink to="/pc-components">Components</KuroLink> &gt; Networking Gear</p>
            <div className="page-title">
                <h1>Networking Gear</h1>
            </div>
            {networkData !== null && networkData.map((prod) =>
                <EditableProd prod={prod} collection="networking" />
            )}
        </div>
    )
}

export default NetworkingGear